import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { MultiLanguageUrl } from "../../constants/multiLanguage.constant";

type Props = {};

function ResetPasswordNavigate({}: Props) {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location: any = useLocation();

  useEffect(() => {
    navigate(
      `/${MultiLanguageUrl[i18n.language] || "en-US"}${location.pathname}${
        location.search
      }`
    );
  }, []);

  return <></>;
}

export default ResetPasswordNavigate;
